import { Enrollment } from "./index"

/**
 * Get profile picture URL from enrollment data
 */
export const getProfilePictureUrl = (enrollment: Enrollment): string => {
  if (enrollment.profilePicture) {
    return enrollment.profilePicture
  }
  
  if (enrollment.user?.profilePicture) {
    return enrollment.user.profilePicture
  }
  
  return "/assets/img/students/student-01.jpg"
}

/**
 * Check if enrollment has a profile picture
 */
export const hasProfilePicture = (enrollment: Enrollment): boolean => {
  return !!(enrollment.profilePicture || enrollment.user?.profilePicture)
}

/**
 * Validate image file for upload
 */
export const validateImageFile = (file: File): { isValid: boolean; error?: string } => {
  const validTypes = ["image/jpeg", "image/jpg", "image/png", "image/gif"]
  if (!validTypes.includes(file.type)) {
    return {
      isValid: false,
      error: "Only image files are allowed (jpeg, jpg, png, gif)",
    }
  }

  const maxSize = 5 * 1024 * 1024 // 5MB
  if (file.size > maxSize) {
    return {
      isValid: false,
      error: "File size should be less than 5MB",
    }
  }

  return { isValid: true }
}
